import { Injectable } from '@angular/core';
import { BehaviorSubject, timer } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NowService {
  now$ = new BehaviorSubject<Date>(new Date());

  constructor() {
    timer(1000, 1000).subscribe(() => {
      this.now$.next(new Date());
    });
  }
}
